import { render, staticRenderFns } from "./TicketMessage.vue?vue&type=template&id=616a8f46&"
import script from "./TicketMessage.vue?vue&type=script&lang=js&"
export * from "./TicketMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports